module.exports = __webpack_public_path__ + "media/images/soar/advantages_money-0000395fb3a9ed5ca3b6b97911303ef3.png";